import { Switch as SwitchDefault } from 'react-router-dom';
import { RouteProps } from 'react-router';
import React, { ReactNode } from 'react';
import { buildPathname } from 'srcJs/helpers/LanguageHelper';
import app from 'srcJs/App';

const Switch = ({
  children,
}) => {
  const renderRoute = (route: ReactNode): React.ReactNode => {
    if (!React.isValidElement<RouteProps>(route)) {
      return route;
    }

    const { path } = route.props;
    let pathNew;
    if (Array.isArray(path)) {
      pathNew = path.map((pathElement) => buildPathname(pathElement, app.getLang()));
    } else {
      pathNew = buildPathname(path, app.getLang());
    }

    return React.cloneElement(route, {
      ...route.props,
      path: pathNew,
    });
  };

  return (
    <SwitchDefault>
      {React.Children.map(children, (child) => renderRoute(child))}
    </SwitchDefault>
  );
};

export { Switch };
